import L from 'lodash'

import { CLASSES as classes } from '@straal/globals/configs/elementConsts'
// @ts-ignore Cannot find module
import { CUSTOM_EVENT_KEY_CODE } from '@straal/assets/staticViews/scripts/consts'

import { addClass, removeClass } from './helpers'

import { STATUS_TYPES as EXPIRED_STATUS_TYPES } from '@straal/globals/configs/expiredConsts'
import { STATUS_TYPES as FORGOT_STATUS_TYPES } from '@straal/globals/configs/forgotConsts'
import { STATUS_TYPES as INVITATION_STATUS_TYPES } from '@straal/globals/configs/invitationConsts'
import { STATUS_TYPES as RESET_PASSWORD_STATUS_TYPES } from '@straal/globals/configs/resetPasswordConsts'

const disableInputs = function(fieldsToDisable: HTMLElement[]): void {
  const disableField = function(input: HTMLElement): void {
    L.set(input, 'disabled', true)
  }

  L.forEach(fieldsToDisable, disableField)
}

const disablePanelContainer = function(
  panelContainer: HTMLElement,
  fieldsToDisable: HTMLElement[],
): void {
  const hasFieldsToDisable = Boolean(fieldsToDisable)

  if (hasFieldsToDisable) disableInputs(fieldsToDisable)

  addClass(panelContainer, classes.DISABLED)
}

export const showThrobber = function(throbberEl: HTMLElement): void {
  addClass(throbberEl, classes.ACTIVE)
}

export const hideThrobber = function(throbberEl: HTMLElement): void {
  removeClass(throbberEl, classes.ACTIVE)
}

export const setFieldValue = function(field: HTMLElement, value: string): void {
  const event = new Event('blur')

  L.set(event, 'keyCode', CUSTOM_EVENT_KEY_CODE)
  L.set(event, 'which', CUSTOM_EVENT_KEY_CODE)

  L.set(field, 'value', value)
  field.dispatchEvent(event)
}

type TStatusType =
  | EXPIRED_STATUS_TYPES
  | FORGOT_STATUS_TYPES
  | INVITATION_STATUS_TYPES
  | RESET_PASSWORD_STATUS_TYPES

export const displayStatusMessage = function({
  type,
  panelContainer,
  statusTypes,
  fieldsToDisable,
}: {
  type: TStatusType
  panelContainer: HTMLElement
  statusTypes: TStatusType[]
  fieldsToDisable: HTMLElement[]
}): void {
  disablePanelContainer(panelContainer, fieldsToDisable)

  const typesIterator = (statusType: TStatusType): void => {
    const element = document.getElementById(statusType)

    if (element) {
      if (L.isEqual(statusType, type)) {
        element.classList.add('active')
      } else {
        element.classList.remove('active')
      }
    }
  }

  L.forEach(statusTypes, typesIterator)
}
